export default __webpack_public_path__ + "static/media/trigger-success.2796b83d.svg";